export const scrollListener = {
  data () {
    return {
      scrolled: false,
      offsetValue: null,
    };
  },
  methods: {
    addScrollListener (offset = 0) {
      this.offsetValue = offset;
      this.scrolled = window.pageYOffset > this.offsetValue;

      document.addEventListener('scroll', this.trackScrolledStatus);
    },
    removeScrollListener (offset = 0) {
      this.offsetValue = offset;

      document.removeEventListener('scroll', this.trackScrolledStatus);
    },
    trackScrolledStatus () {
      this.scrolled = window.pageYOffset > this.offsetValue;
    },
  },
};
